import axios from 'axios'

export default class ApiClient {
  constructor () {
    this.baseURL = process.env.NODE_ENV === 'local' ? `http://${window.location.hostname}:8080` : process.env.VUE_APP_URLS_API

    this._instance = axios.create({ baseURL: this.baseURL })

    this.get = this._instance.get
    this.post = this._instance.post
    this.put = this._instance.put
    this.delete = this._instance.delete
    this.patch = this._instance.patch
    this.head = this._instance.head
    this.option = this._instance.option

    this._tokenChangeCallBacks = []
  }

  get token () {
    return this._token
  }

  set token (token) {
    this._tokenChangeCallBacks.forEach(f => f(token))
    this._token = token
  }

  onTokenChanged (f) {
    this._tokenChangeCallBacks.push(f)
  }

  async retrieveNewToken () {
    try {
      this.token = await this._getToken()
      return this.token
    } catch (e) {
      console.error('[ApiClient]: ' + e.message)
      throw new Error(e.response)
    }
  }
}
